// extracted by mini-css-extract-plugin
export default {"consumers":"Consumers_consumers__9ezwF","con":"Consumers_con__DAfG7","logoname":"Consumers_logoname__csAo0"};